module.exports = __webpack_public_path__ + "static/_0011_ISHA-3727d19b87aa55f11e0d2b20f420a778.jpg";